import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Alert icon for representing warnings or important notifications
 */
export const AlertIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </Icon>
  );
};

export default AlertIcon;
